import React, { useEffect, useState } from 'react';
import { IInsuredDetails } from '.';
import { useLazyQuery } from '@apollo/client';
import { getInsuredDetailsInfo, getPolicyList } from './queries';
import { useParams } from 'react-router-dom';
import InsuredDetailsEntityInfo from './InsuredDetailsEntityInfo';
import { GetInsuredData, dataToLovs, mapToListingData } from './utils';
import { InsuredDetailsWidget } from './InsuredDetailsWidget';
import { headers } from './content';
import { IListingData } from '@models/listing';
import StaticLayout from '@components/layout/StaticLayout';
import ListingWidget from '@components/widgets/listing-widget/ListingWidget';
import { IFilterModel } from '@components/widgets/listing-widget';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
}));

const InsuredDetailsPage: React.FC = () => {
  const { classes } = useStyles();
  const [loading, setLoading] = useState<boolean>(true);
  const { id: currentInsuredId } = useParams<{ id: string }>();

  const [data, setData] = useState<IInsuredDetails>();
  const [lovs, setLovs] = useState<Record<string, Record<string, string>>>({});

  const [tableData, setTableData] = useState<IListingData>({
    pagedItems: {},
    pageSize: 10,
    pageNumber: 1,
    totalCount: 0,
  });

  useEffect(() => {
    initialize();
  }, []);

  const [getProposalDetailsLazy] = useLazyQuery(getInsuredDetailsInfo);
  const [policyListResultQuery, { loading: policiesLoading }] =
    useLazyQuery(getPolicyList);

  const getPoliciesList = async (filterModel: IFilterModel) => {
    const { data } = await policyListResultQuery({
      variables: {
        pagination: filterModel.pagination,
        Attribute: filterModel.orderBy,
        Descending: filterModel.descending,
        KeywordSearch: filterModel.searchKey,
        selectedInsuredIDs: currentInsuredId,
      },
      errorPolicy: 'all',
    });

    const mappedTableData = mapToListingData(data);
    setTableData(mappedTableData);
  };

  const initialize = async () => {
    const { data } = await getProposalDetailsLazy({
      variables: { id: currentInsuredId },
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    });
    const summaryData = GetInsuredData(data);

    setLovs(dataToLovs(data));
    setData(summaryData);
    setLoading(false);
  };

  const renderMainChildren = () => (
    <div className={classes.container}>
      <InsuredDetailsWidget data={data} lovs={lovs} />
      <ListingWidget
        inlineTitle="Policies"
        title=""
        name="Policies"
        orderByAscendingByDefault
        inline
        data={tableData}
        tableSettings={{
          headers: headers,
        }}
        loading={policiesLoading}
        defaultOrderByColumn="Production_Policy_PolicyName"
        actions={[]}
        usePagination
        disableSelection
        onPageChange={getPoliciesList}
      />
    </div>
  );

  return (
    <StaticLayout
      loading={loading}
      name={'Insured Details'}
      leftChildren={<InsuredDetailsEntityInfo data={data} />}
      mainChildren={renderMainChildren()}
    />
  );
};

export default InsuredDetailsPage;
